// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class CaseHomeHealthAgencyRelationshipModel {
    'homeHealthAgencyId'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof CaseHomeHealthAgencyRelationshipModel>> = [
        {
            "name":     "homeHealthAgencyId",
            "baseName": "homeHealthAgencyId",
            "type":     "number"
        },
    ];

    static getAttributeTypeMap() {
        return CaseHomeHealthAgencyRelationshipModel.attributeTypeMap;
    }
}
